// @ngInject
function stateConfig($stateProvider) {

    $stateProvider.state('base.invoicetypes.new', {
        url:'/new',
        views: {
            'baseView@base': {
            templateUrl: 'main/base/invoicetypes/invoicetype/invoicetype.tpl.html',
            controller: 'InvoiceTypeController as vm'
        }},
        resolve: {
            invoicetype: function() { return {}; },
            languages: languagesResolver,
            isNewInvoiceType: function() {return true;},
            printDocumentTemplates: printDocumentResolver
        }
    });

    $stateProvider.state('base.invoicetypes.invoicetype', {
        url:'/{invoicetypeId}',
        views: {
            'baseView@base': {
            templateUrl: 'main/base/invoicetypes/invoicetype/invoicetype.tpl.html',
            controller: 'InvoiceTypeController as vm'
        }},
        resolve: {
            invoicetype: invoicetypeResolver,
            languages: languagesResolver,
            isNewInvoiceType: function() {return false;},
            printDocumentTemplates: printDocumentResolver
        }
    });

}

// @ngInject
function invoicetypeResolver($stateParams, InvoiceTypesApiService) {
    return InvoiceTypesApiService.getInvoiceType($stateParams.invoicetypeId);
}

// @ngInject
function languagesResolver($stateParams, InvoiceTypesApiService) {
    return InvoiceTypesApiService.getLanguages();
}

// @ngInject
function printDocumentResolver($stateParams, InvoiceTypesApiService) {
    return InvoiceTypesApiService.getPrintDocumentTemplates();
}

// @ngInject
function InvoiceTypeController($state, invoicetype, loadSpinnerService, InvoiceTypesApiService, ToasterService, confirmationDialogService, $translate, isNewInvoiceType, languages, printDocumentTemplates) {
    var vm = this;

    var invoicetypeCopy = {};

    vm.invoicetype = invoicetype;
    vm.devFeaturesEnabled = localStorage.getItem('devFeature_reactInvoiceTypeView') === 'true';
    vm.reactInvoiceTypeId = isNewInvoiceType ? null : (invoicetype && invoicetype.id != null ? invoicetype.id : null);

    vm.enableEditing = enableEditing;
    vm.cancelEditing = cancelEditing;
    vm.saveInvoiceType = saveInvoiceType;
    vm.deleteInvoiceType = deleteInvoiceType;

    vm.isNewInvoiceType = isNewInvoiceType;
    vm.isEditing = vm.isNewInvoiceType;
    vm.isAllInformationValid = isAllInformationValid;
    vm.languages = languages;
    vm.printDocumentTemplates = printDocumentTemplates;

    vm.toggleDisplayForm = toggleDisplayForm;

    activate();

    function activate() {
        prepareData();
        if (vm.isNewInvoiceType) {
            vm.invoicetype = {};
        }

        appendLocalizations(vm.invoicetype, vm.languages);

    }

    function appendLocalizations(obj, languages) {
        if (!obj.localizations) {
            obj.localizations = [];
        }
        _.forEach(languages, function(language) {
            if (_.filter(obj.localizations, { language: { id: language.id}}).length === 0) {
                obj.localizations.push({ language: language });
            }
        });
    }

    function enableEditing() {
        invoicetypeCopy = angular.copy(vm.invoicetype);
        vm.isEditing = true;
    }

    function cancelEditing() {
        vm.invoicetype = invoicetypeCopy;
        vm.isEditing = false;
    }

    function saveInvoiceType() {
        if (vm.isNewInvoiceType) {
            saveNewInvoiceType();
        } else {
            updateInvoiceType();
        }
    }

    function saveNewInvoiceType() {
        loadSpinnerService.start('mainSpinner');
        InvoiceTypesApiService.createInvoiceType(vm.invoicetype).then(function(response) {
            vm.invoicetype = response;
            prepareData();
            vm.isNewInvoiceType = false;
            vm.isEditing = false;
            $state.go('base.invoicetypes.invoicetype', {invoicetypeId: vm.invoicetype.id});
        }, function(error) {
            console.log(error);
            ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
        }).then(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function updateInvoiceType() {
        loadSpinnerService.start('mainSpinner');

        InvoiceTypesApiService.updateInvoiceType(vm.invoicetype).then(function(response) {
            vm.invoicetype = response;
            prepareData();
            vm.isNewInvoiceType = false;
            vm.isEditing = false;
            $state.go('base.invoicetypes.invoicetype', {invoicetypeId: vm.invoicetype.id});
        }, function(error) {
            console.log(error);
            ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
        }).then(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function deleteInvoiceType() {
        confirmationDialogService
            .showDialog($translate.instant('invoicetype.confirmDelete'))
            .then(function(confirmation) {
                if (confirmation) {
                    loadSpinnerService.start('mainSpinner');
                    InvoiceTypesApiService.deleteInvoiceType(vm.invoicetype.id).then(function(response) {
                        vm.invoicetype = response;
                        prepareData();
                        vm.isNewInvoiceType = false;
                        vm.isEditing = false;
                        $state.go('base.invoicetypes');
                    }, function(error) {
                        console.log(error);
                        ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
                    }).then(function() {
                        loadSpinnerService.stop('mainSpinner');
                    });
                }
            });
    }

    function toggleDisplayForm(invoicetype) {
        invoicetype.showEditForm = !invoicetype.showEditForm;
    }

    function prepareData() {
        if (vm.invoicetype === undefined) {
            return;
        }

        vm.invoicetypeCopy = angular.copy(vm.invoicetype);
    }

    function isAllInformationValid() {
        return true;
    }

    function isNumeric(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    }

}

angular
    .module('invoicetypes.invoicetype', [])
    .config(stateConfig)
    .controller('InvoiceTypeController', InvoiceTypeController);
